import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card";
import { Loader2, AlertCircle } from "lucide-react";

const ReportWidget = ({ title, value, icon, loading, error, format }) => {
  const IconComponent = icon;

  const renderContent = () => {
    if (loading) {
      return (
        <div className="flex items-center justify-center h-full">
          <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        </div>
      );
    }
    if (error) {
      return (
        <div className="flex flex-col items-center justify-center h-full text-destructive">
          <AlertCircle className="h-6 w-6 mb-1" />
          <p className="text-sm">Erro ao carregar</p>
        </div>
      );
    }

    let formattedValue = value;
    if (format) {
      if (format.type === "currency") {
        formattedValue = value.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        });
      } else if (format.type === "percent") {
        formattedValue = `${value}%`;
      }
    }

    return (
      <div className="text-4xl font-bold tracking-tighter">
        {formattedValue}
      </div>
    );
  };

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-base font-medium">{title}</CardTitle>
        {IconComponent && (
          <IconComponent className="h-5 w-5 text-muted-foreground" />
        )}
      </CardHeader>
      <CardContent>{renderContent()}</CardContent>
    </Card>
  );
};

export default ReportWidget;
